import Api from '@/services/Api';

export default {
    getDocumenti(idBonus) {
        return Api().get('/asseverazione/tipi/' + idBonus);
    },

    getAsseverazioni() {
        return Api().get('/asseverazione');
    },

    createAsseverazione(dati) {
        return Api().post('/asseverazione', dati);
    },
    
    // deleteAsseverazione(id) {
    //     return Api().delete('/asseverazione/' + id);
    // },

    getAsseverazione(id) {
        return Api().get('/asseverazione/' + id);
    },

    // updateAsseverazione(id, dati) {
    //     return Api().put('/asseverazione/' + id, dati);
    // },

    // changePage(page, n_righe) {
    //     return Api().get('/asseverazione?page=' + page + '&limit=' + n_righe);
    // },
}